$('input[name="reminder[select]"]').change(function(){

    if ($(this).val()==1) {
        $('input[name="reminder[email]"]').parent().removeClass('d-none');
        $('input[name="reminder[phone]"]').parent().addClass('d-none');
    } else {
        $('input[name="reminder[email]"]').parent().addClass('d-none');
        $('input[name="reminder[phone]"]').parent().removeClass('d-none');
    }
});
$('.btn_notify').click(function(e){
    e.preventDefault();
    var t = this;
    $.ajax({
        url:     '/local/templates/taganrogotoplenie/ajax/reminder.php', 
        type:     "POST",
        dataType: "html",
        data: "ID="+$(this).attr("data-id")+'&TYPE=ADD',
        success: function(response) {
          console.log(response);
          if (response=="show_form" || response==""){
            $('#notify').modal('show');
            $(t).addClass('btn_danger text-white').text('уведомим');
          }else
          if (response=="need_auth"){ 
            $('.header__link[data-target="#auth"]').click();
          }else     
          if (response=="remove"){
            $(t).removeClass('btn_danger text-white').text('уведомить');
 
          }else {
            console.log(response);
          }       
                  
        },   
        error: function(jqXHR, textStatus, errorThrown){ 
            console.log('Error: '+ errorThrown);
        } 
    });
});

$('form[name="form_reminder"] .btn_submit').click(function(){
    $('input[name="reminder[email]"]').removeClass('js-error');
    $('input[name="reminder[phone]"]').removeClass('js-error');
    $('.js-error').remove();
   
    var error = false;

    var re = /\S+@\S+\.\S+/; 
    if ($('input[name="reminder[select]"]:checked').val()==1) {
        if (!re.test($('input[name="reminder[email]"]').val())){
            $('input[name="reminder[email]"]').addClass('js-error').after('<label class="js-error">Введите корректный E-MAIL</label>');
            error= true;
        }
    }
    if ($('input[name="reminder[select]"]:checked').val()==2) {
        var phone = $('input[name="reminder[phone]"]').val().replace(/[+_ ()-]/gi, '');
        if (phone.length<11) {
            $('input[name="reminder[phone]"]').addClass('js-error').after('<label class="js-error">Введите номер телефона</label>');
            error= true;
        }
    }  
    if (!error) {
        $.ajax({
            url:     '/local/templates/taganrogotoplenie/ajax/reminder.php', 
            type:     "POST",
            dataType: "html",
            data: $('form[name="form_reminder"]').serialize()+'&TYPE=REG',
            success: function(response) {  
                console.log(response);
                if (response=='reg')
                    $('#notify').modal('hide');
                else 
                    console.log(response);
            },  
            error: function(jqXHR, textStatus, errorThrown){  
                console.log('Error: '+ errorThrown); 
            } 
        });       
    }


});  
 
